import React from 'react';
import { Route, Routes as ReactRoutes, Navigate } from "react-router-dom";
import { usePermissions } from '../context/AuthContext';
import Dashboard from './Dashboard/Dashboard';
import Header from '../components/common/Header';
import CouponsList from './Coupons/CouponsList';
import CouponsAdd from './Coupons/CouponsAdd';
import CouponsEdit from './Coupons/CouponsEdit';
import StaterPage from './Stater Page/StaterPage';
import TeamStaffList from './Users/UsersList';
import TeamStaffAdd from './Users/UsersAdd';
import AddFAQ from './FAQ/AddFAQ';
import FAQList from './FAQ/FAQList';
import ExpertiseAdd from './Expertise/ExpertiseAdd';
import ExpertiseEdit from './Expertise/ExpertiseEdit';
import ExpertiseList from './Expertise/ExpertiseList';
import HeatMapBox from './HeatMap/HeatMapBox';
import PrivacyPolicy from './PrivacyPolicy/PrivacyPolicy';
import AstrologerList from './Astrologer/AstrologerList';
import AstrologerAdd from './Astrologer/AstrologerAdd';
import AstoReqView from './Astrologer/AstoReqView';
import AstrolgerBooking from './Astrologer/AstrolgerBooking';
import BookingAdd from './Booking/BookingAdd';
import BookingDetails from './Booking/BookingDetails';
import BookingEdit from './Booking/BookingEdit';
import BookingList from './Booking/BookingList';
import BookingPassword from './Booking/BookingPassword';
import BookingForgetPassword from './Booking/BookingForgetPassword';
import ChatHistory from './Booking/ChatHistory';
import LanguageAdd from './Language/LanguageAdd';
import LanguageList from './Language/LanguageList';
import SkillAdd from './Skill/SkillAdd';
import SkillList from './Skill/SkillList';
import CourseAdd from './Course/CourseAdd';
import CourseList from './Course/CourseList';
import CategoryAdd from './Category/CategoryAdd';
import CategoryEdit from './Category/CategoryEdit';
import CategoryList from './Category/CategoryList';
import StudentList from './Student/StudentList';
import LeadsList from './Leads/LeadsList';
import StudentView from './Student/StudentView';
import ListReviewCourse from './Reviews/CourseSpecific/ListReviewCourse';
import AddReviewCourse from './Reviews/CourseSpecific/AddReviewCourse';
import CourseBanner from './Banners/CourseBanner';
import TermsAndCondition from './TermsAndConditions/TermsAndCondition';
import AboutUs from './AboutUs/AboutUsScreens';
import RefundPolicy from './RefundPolicy/RefundPolicy';
import InstructorLeads from './InstructorLeads/InstructorLeads';
import SupportQuery from './Support/SupportQuery';
import SupportQueryView from './Support/SupportQueryView';
import EductionCouponList from './EductionCoupon/EductionCouponList';
import EducationCouponAdd from './EductionCoupon/EducationCouponAdd';
import ListGooglePayCoupon from './GooglePayCoupon/ListGooglePayCoupon';
import AddGooglePayCoupon from './GooglePayCoupon/AddGooglePayCoupon';
import ViewGoogleCopon from './GooglePayCoupon/ViewGoogleCopon';
import ListOffer from './OfferModules/Listoffer';
import AddOffer from './OfferModules/AddOffer';
import ListGeneric from './GenericFaq/ListGeneric';
import AddReferEarnFAQs from './ReferEarnFAQs/AddReferEarnFAQs';
import ListReferEarnFAQs from './ReferEarnFAQs/ListReferEarnFAQs';
import AddGeneric from './GenericFaq/AddGeneric';
import ListReview from './GenericReview/ListReview';
import AddReview from './GenericReview/AddReview';
import ListConsultationCoupon from './ConsultationCoupon/ListConsultationCoupon';
import AddConsultationCoupon from './ConsultationCoupon/AddConsultationCoupon';
import UserFeedbackList from './UserFeedBack/userfeedbackList';
import AstrologerSupportList from './AstrologerSupport/AstrologerSupportList';
import AstroSupportDetails from './AstrologerSupportDetails/AstroSupportDetails';
import AstroSupportView from './AstrologerSupportDetails/AstroSupportView';
import ConsultationList from './ConsultationVoucher/ConsultationList';
import ConsultationAdd from './ConsultationVoucher/ConsultationAdd';
import Notification from './Notification/Notification';
import AstroSupportChat from './AstrologerSupport/AstroSupportChat';
import UserMessageView from './UserFeedBack/UserMessageView';
import FeedbackCallbackList from './CallbackRequests/FeedbackCallbackList';
import DailyRechargeReport from './Reports/DailyRechargeReports';
import InvoiceReportList from './Reports/InVoiceReports';
import CourseSellingReport from './Reports/CourseSellingReport';
import SessionReports from './Reports/SessionReport';
import CouponUsesReport from './Reports/CouponUsesReport';
import CreditReports from './Reports/CreditReports';
import PayoutReports from './Reports/PayoutReports';
import PayoutReportView from './Reports/PayoutReportView';
import WalletReport from './Reports/WalletReport';
import RevenueConsultationReport from './Reports/RevenueConsultationReport';
import UserBookings from './Users/UserBookings';
import AstroList from './AstroTag/AstroList';
import AstroTag from './AstroTag/AstroTag';
import UserSupportList from './UserSupport/UserSupportList';
import UserSupportChat from './UserSupport/UserSupportChat';
import UserRole from './RoleAndUser/User/UserRole';
import AddRole from './RoleAndUser/Role/AddRole';
import RoleAndUserManagment from './RoleAndUser/Role/RoleAndUserManagment';
import AddUserrole from './RoleAndUser/User/AddUserrole';
import TopBanner from './BannerManagment/TopBanner/TopBanner';
import AppViewBanner from './BannerManagment/TopBanner/AppViewBanner';
import AddMobileBanner from './BannerManagment/TopBanner/AddMobileBanner';
import AddWebBanner from './BannerManagment/TopBanner/AddWebBanner';
import ConsultationType from './BannerManagment/ConsultationType/ConsultationType';
import ServicesType from './BannerManagment/ServicesType/ServicesType';
import ForceUpdate from './ForceUpdate/forceUpdate';

const allRoutes = [
    // === Dashboard ===
    { path: "/dashboard", Component: Dashboard, requiredPrivilege: "dashboard:view" },
    { path: '/stater-page', Component: StaterPage, requiredPrivilege: 'dashboard:view' },

    // === App Management ===
    { path: '/force-update', Component: ForceUpdate, requiredPrivilege: '/force-update', category: '/app-management' },

    // === Role & User Management ===
    { path: '/role-management', Component: RoleAndUserManagment, requiredPrivilege: 'role_management:list' },
    { path: '/addrole', Component: AddRole, requiredPrivilege: 'role_management:add' },
    { path: '/useree/:id', Component: AddRole, requiredPrivilege: 'role_management:edit' },
    { path: '/user-management', Component: UserRole, requiredPrivilege: 'user_management:list' },
    { path: '/user-role-add', Component: AddUserrole, requiredPrivilege: 'user_management:add' },
    { path: '/user-role-edit/:id', Component: AddUserrole, requiredPrivilege: 'user_management:edit' },

    // === Users ===
    { path: '/users-list', Component: TeamStaffList, requiredPrivilege: 'users:list' },
    { path: '/users-add', Component: TeamStaffAdd, requiredPrivilege: 'users:add' },
    { path: '/users-edit/:id', Component: TeamStaffAdd, requiredPrivilege: 'users:edit' },
    { path: '/booking-by-user/:userId', Component: UserBookings, requiredPrivilege: 'users:list' },

    // === Astrologers ===
    { path: '/astrologer-list', Component: AstrologerList, requiredPrivilege: 'astrologers:list' },
    { path: '/astrologer-add', Component: AstrologerAdd, requiredPrivilege: 'astrologers:add' },
    { path: '/astrologer-edit/:id', Component: AstrologerAdd, requiredPrivilege: 'astrologers:edit' },
    { path: '/astrologerreq-view/:id', Component: AstoReqView, requiredPrivilege: 'astrologers:approve' },
    { path: '/booking-by-astro/:astoID', Component: AstrolgerBooking, requiredPrivilege: 'astrologers:list' },

    // === Tag Management ===
    { path: '/astro-tag-management', Component: AstroList, requiredPrivilege: 'astro_tags:list' },
    { path: '/tag-add', Component: AstroTag, requiredPrivilege: 'astro_tags:add' },
    { path: '/tag-edit/:id', Component: AstroTag, requiredPrivilege: 'astro_tags:edit' },

    // === Expertise Management ===
    { path: '/expertise-list', Component: ExpertiseList, requiredPrivilege: 'expertise:list' },
    { path: '/expertise-add', Component: ExpertiseAdd, requiredPrivilege: 'expertise:add' },
    { path: '/expertise-edit/:id', Component: ExpertiseEdit, requiredPrivilege: 'expertise:edit' }, // ExpertiseEdit component was in old file

    // === Language & Skill Management ===
    { path: '/language-list', Component: LanguageList, requiredPrivilege: 'languages:list' },
    { path: '/language-add', Component: LanguageAdd, requiredPrivilege: 'languages:add' },
    { path: '/language-edit/:id', Component: LanguageAdd, requiredPrivilege: 'languages:edit' }, // Assuming edit uses the Add component
    { path: '/skill-list', Component: SkillList, requiredPrivilege: 'skills:list' },
    { path: '/skill-add', Component: SkillAdd, requiredPrivilege: 'skills:add' },
    { path: '/skill-edit/:id', Component: SkillAdd, requiredPrivilege: 'skills:edit' },

    // === Education -> Category Management ===
    { path: '/category-management', Component: CategoryList, requiredPrivilege: 'category_management:list' },
    { path: '/category-add', Component: CategoryAdd, requiredPrivilege: 'category_management:add' },
    { path: '/category-edit/:id', Component: CategoryEdit, requiredPrivilege: 'category_management:edit' },

    // === Booking Management ===
    { path: '/booking-list', Component: BookingList, requiredPrivilege: 'bookings:list' },
    { path: '/booking-add', Component: BookingAdd, requiredPrivilege: 'bookings:add' },
    { path: '/booking-edit/:id', Component: BookingEdit, requiredPrivilege: 'bookings:edit' },
    { path: '/booking-details/:id', Component: BookingDetails, requiredPrivilege: 'bookings:list' },
    { path: '/booking-password', Component: BookingPassword, requiredPrivilege: 'bookings:password' },
    { path: '/booking-password/Forget', Component: BookingForgetPassword, requiredPrivilege: 'bookings:password' },
    { path: '/chat-history/:userId/:astroId', Component: ChatHistory, requiredPrivilege: 'bookings:list' },

    // === Education -> Course Management ===
    { path: '/course-management', Component: CourseList, requiredPrivilege: 'course_management:list' },
    { path: '/course-add', Component: CourseAdd, requiredPrivilege: 'course_management:add' },
    { path: '/course-edit/:id', Component: CourseAdd, requiredPrivilege: 'course_management:edit' },

    // === Education -> Student & Leads Management ===
    { path: '/student-management', Component: StudentList, requiredPrivilege: 'student_management:list' },
    { path: '/student-view/:id', Component: StudentView, requiredPrivilege: 'student_management:list' },
    { path: '/leads-management', Component: LeadsList, requiredPrivilege: 'lead_management:list' },
    { path: '/instructor-leads', Component: InstructorLeads, requiredPrivilege: 'instructor_leads:list' },

    // === Coupon Management (Legacy & New) ===
    { path: '/coupons-list', Component: CouponsList, requiredPrivilege: 'consultation_coupons:list' }, // Mapping legacy to consultation
    { path: '/coupons-add', Component: CouponsAdd, requiredPrivilege: 'consultation_coupons:add' },
    { path: '/coupons-edit/:id', Component: CouponsEdit, requiredPrivilege: 'consultation_coupons:edit' },
    { path: '/eduction-modulecoupon', Component: EductionCouponList, requiredPrivilege: 'education_coupons:list' },
    { path: '/educationcoupon-add', Component: EducationCouponAdd, requiredPrivilege: 'education_coupons:add' },
    { path: '/consultation-coupon', Component: ListConsultationCoupon, requiredPrivilege: 'consultation_coupons:list' },
    { path: '/consultation-add', Component: AddConsultationCoupon, requiredPrivilege: 'consultation_coupons:add' },
    { path: '/googlepay-coupon', Component: ListGooglePayCoupon, requiredPrivilege: 'google_pay_coupons:list' },
    { path: '/googlepaycoupon-add', Component: AddGooglePayCoupon, requiredPrivilege: 'google_pay_coupons:add' },
    { path: '/google-view/:id', Component: ViewGoogleCopon, requiredPrivilege: 'google_pay_coupons:list' },

    // === Consultation Voucher ===
    { path: '/consultation-voucher', Component: ConsultationList, requiredPrivilege: 'consultation_vouchers:list' },
    { path: '/consultationvoucher-add', Component: ConsultationAdd, requiredPrivilege: 'consultation_vouchers:add' },
    { path: '/Concoupons-edit/:id', Component: ConsultationAdd, requiredPrivilege: 'consultation_vouchers:edit' },

    // === Offer Management ===
    { path: '/offer-list', Component: ListOffer, requiredPrivilege: 'offers:list' },
    { path: '/offer-add', Component: AddOffer, requiredPrivilege: 'offers:add' },
    { path: '/offer-edit/:id', Component: AddOffer, requiredPrivilege: 'offers:edit' },

    // === Banner Management ===
    { path: '/top-banners', Component: TopBanner, requiredPrivilege: 'top_banners:list' },
    { path: '/web-edit/:id', Component: AddWebBanner, requiredPrivilege: 'top_banners:edit' },
    { path: '/app-edit/:id', Component: AppViewBanner, requiredPrivilege: 'top_banners:edit' },
    { path: '/mobile-edit/:id', Component: AddMobileBanner, requiredPrivilege: 'top_banners:edit' },
    { path: '/appView-banners', Component: AppViewBanner, requiredPrivilege: 'top_banners:list' }, // View routes
    { path: '/mobileView-banners', Component: AddMobileBanner, requiredPrivilege: 'top_banners:list' },
    { path: '/webView-banners', Component: AddWebBanner, requiredPrivilege: 'top_banners:list' },
    { path: '/course-banners', Component: CourseBanner, requiredPrivilege: 'course_banners:list' },
    { path: '/consultation-type', Component: ConsultationType, requiredPrivilege: 'consultation_type_banners:list' },
    { path: '/service-banners', Component: ServicesType, requiredPrivilege: 'service_banners:list' },

    // === Review Management ===
    { path: '/course-specific', Component: ListReviewCourse, requiredPrivilege: 'course_specific_reviews:list' },
    { path: '/AddReviewCourse', Component: AddReviewCourse, requiredPrivilege: 'course_specific_reviews:add' },
    { path: '/editReviewCourse/:id', Component: AddReviewCourse, requiredPrivilege: 'course_specific_reviews:edit' },
    { path: '/generic-reviews', Component: ListReview, requiredPrivilege: 'generic_reviews:list' },
    { path: '/genericreview-add', Component: AddReview, requiredPrivilege: 'generic_reviews:add' },
    { path: '/review-edit/:id', Component: AddReview, requiredPrivilege: 'generic_reviews:edit' },

    // === FAQ Management ===
    { path: '/course-specificfaq', Component: FAQList, requiredPrivilege: 'course_specific_faqs:list' },
    { path: '/faq-add', Component: AddFAQ, requiredPrivilege: 'course_specific_faqs:add' },
    { path: '/faq-edit/:id', Component: AddFAQ, requiredPrivilege: 'course_specific_faqs:edit' },
    { path: '/generic-faq', Component: ListGeneric, requiredPrivilege: 'generic_faqs:list' },
    { path: '/generic-add', Component: AddGeneric, requiredPrivilege: 'generic_faqs:add' },
    { path: '/faqger-edit/:id', Component: AddGeneric, requiredPrivilege: 'generic_faqs:edit' },
    { path: '/refer-faq', Component: ListReferEarnFAQs, requiredPrivilege: 'refer_earn_faqs:list' },
    { path: '/referadd', Component: AddReferEarnFAQs, requiredPrivilege: 'refer_earn_faqs:add' },
    { path: '/referadd/:id', Component: AddReferEarnFAQs, requiredPrivilege: 'refer_earn_faqs:edit' },

    // === Support, Chat & Feedback ===
    { path: '/user-feedback', Component: UserFeedbackList, requiredPrivilege: 'user_feedback:list' },
    { path: '/MessageView-detail/:id', Component: UserMessageView, requiredPrivilege: 'user_feedback:list' },
    { path: '/user-support', Component: UserSupportList, requiredPrivilege: 'user_tickets:list' },
    { path: '/user-chat/:id', Component: UserSupportChat, requiredPrivilege: 'user_tickets:reply' },
    { path: '/astrologer-support', Component: AstrologerSupportList, requiredPrivilege: 'astrologer_tickets:list' },
    { path: '/astrologer-supporttiket', Component: AstroSupportDetails, requiredPrivilege: 'astrologer_support_details:list' },
    { path: '/AstroView-detail/:id', Component: AstroSupportView, requiredPrivilege: 'astrologer_tickets:list' },
    { path: '/AstroSupportChat/:id', Component: AstroSupportChat, requiredPrivilege: 'astrologer_tickets:reply' },
    { path: '/support-query', Component: SupportQuery, requiredPrivilege: 'user_tickets:list' }, // Mapped legacy to user_tickets
    { path: '/support-query-view/:id', Component: SupportQueryView, requiredPrivilege: 'user_tickets:list' },
    { path: '/callback-requests', Component: FeedbackCallbackList, requiredPrivilege: 'callback_requests:list' },

    // === Reports ===
    { path: '/daily-recharge', Component: DailyRechargeReport, requiredPrivilege: 'daily_recharge_report:view' },
    { path: '/invoice-reports', Component: InvoiceReportList, requiredPrivilege: 'invoice_reports:view' },
    { path: '/session-reports', Component: SessionReports, requiredPrivilege: 'session_report:view' },
    { path: '/coupon-usesreport', Component: CouponUsesReport, requiredPrivilege: 'coupon_usage_report:view' },
    { path: '/credit-reports', Component: CreditReports, requiredPrivilege: 'credit_note_report:view' },
    { path: '/payout-reports', Component: PayoutReports, requiredPrivilege: 'payout_report:view' },
    { path: '/payout-reportsView/:id', Component: PayoutReportView, requiredPrivilege: 'payout_report:view' },
    { path: '/course-selling-report', Component: CourseSellingReport, requiredPrivilege: 'course_selling_report:view' },
    { path: '/wallet-report', Component: WalletReport, requiredPrivilege: 'wallet_report:view' },
    { path: '/revenue-consultation-report', Component: RevenueConsultationReport, requiredPrivilege: 'revenue_consultation_report:view' },
    { path: '/heat-map', Component: HeatMapBox, requiredPrivilege: 'dashboard:view' }, // Mapped to dashboard as no specific privilege exists

    // === Static Info Pages (CMS) ===
    { path: '/privacy-policy', Component: PrivacyPolicy, requiredPrivilege: 'privacy_policy:view' },
    { path: '/terms-conditions', Component: TermsAndCondition, requiredPrivilege: 'terms_conditions:view' },
    { path: '/about-us', Component: AboutUs, requiredPrivilege: 'about_us:view' },
    { path: '/refund-policy', Component: RefundPolicy, requiredPrivilege: 'refund_policy:view' },

    // === Notifications ===
    { path: '/notification-list', Component: Notification, requiredPrivilege: 'notifications:list' },
];

const PrivateRoute = ({ children, requiredPrivilege }) => {
    const { can } = usePermissions();
    if (can(requiredPrivilege)) {
        return children;
    }
    return <Navigate to={process.env.PUBLIC_URL + "/unauthorized"} />;
};

const Unauthorized = () => (
    <div className='d-flex justify-content-center align-items-center' style={{ height: '60vh' }}>
        <div className='text-center'>
            <h2 className='text-danger'>403 - Access Denied</h2>
            <p className='text-muted'>You do not have the required permissions to view this page.</p>
        </div>
    </div>
);

function MainIndex(props) {
    const { activekey } = props;
    const { privileges, loading } = usePermissions();

    if (loading) {
        return (
            <div className='d-flex justify-content-center align-items-center vh-100'>
                <h2>Loading Permissions...</h2>
            </div>
        );
    }

    const userToken = localStorage.getItem("vedhvidhi-admin-token");
    if (!userToken) {
        return <Navigate to={process.env.PUBLIC_URL + "/sign-in"} />;
    }

    const isSuperAdmin = privileges.includes('SUPER_ADMIN');

    return (
        <div className='main px-lg-4 px-md-4'>
            {activekey !== "/chat" && <Header />}
            <div className="body d-flex py-3">
                <ReactRoutes>
                    <Route path={process.env.PUBLIC_URL + "/"} element={<Navigate to={`${process.env.PUBLIC_URL}/dashboard`} />} />
                    <Route path={process.env.PUBLIC_URL + "/unauthorized"} element={<Unauthorized />} />
                    {allRoutes.map(({ path, Component, requiredPrivilege }) => (
                        <Route
                            key={path}
                            path={process.env.PUBLIC_URL + path}
                            element={
                                <PrivateRoute requiredPrivilege={requiredPrivilege}>
                                    <Component />
                                </PrivateRoute>
                            }
                        />
                    ))}
                    <Route
                        path="*"
                        element={
                            isSuperAdmin
                                ? <Navigate to={`${process.env.PUBLIC_URL}/dashboard`} />
                                : <Unauthorized />
                        }
                    />
                </ReactRoutes>
            </div>
        </div>
    );
}

export default MainIndex;
